export default {
   checkoutResponse: {
      legs: {
         1: {
            index: 1,
            route: "AYT-DUS",
            date: "2026-02-28T21:45:00",
            channelId: 193,
            flightIdentifier: "193_2602282145PC8043282145PC16870107151P472",
            selectedBrandIdentifier: "193_2602282145PC8043282145PC16870107151P472",
            brands: {
               "193_2602282145PC8043282145PC16870107151LTE=": {
                  index: 1,
                  selected: false,
                  disabled: false,
                  estimatedPrice: false,
                  identifier: "193_2602282145PC8043282145PC16870107151LTE=",
                  brandCode: "LTE=",
                  brandName: "Light",
                  brandTitle: "Light",
                  baggageInfo: "0KG",
                  flightClass: "I",
                  cabinType: 1,
                  features: [
                     {
                        type: 8,
                        state: 2,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                     },
                     {
                        type: 1,
                        state: 1,
                        info: "0 Kg Check-in Baggage",
                     },
                     {
                        type: 5,
                        state: 2,
                        info: "Refund/Reissue without Penalty",
                     },
                     {
                        type: 2,
                        state: 2,
                        info: "Standard Seat Selection",
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Feta Cheese Sandwich",
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Chicken Sandwich",
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Bike",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Movies, TV Series, Music, Games",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "RFISC:SCHD",
                     },
                  ],
                  ssrs: [
                     {
                        type: 8,
                        state: 2,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                        paxes: {},
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                        paxes: {},
                     },
                     {
                        type: 5,
                        state: 2,
                        info: "Refund/Reissue without Penalty",
                        paxes: {},
                     },
                     {
                        type: 2,
                        state: 2,
                        info: "Standard Seat Selection",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Feta Cheese Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Chicken Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Bike",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Movies, TV Series, Music, Games",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "RFISC:SCHD",
                        paxes: {},
                     },
                  ],
                  total: {
                     source: "-84.00",
                     parsedValue: -84,
                  },
                  currency: "EUR",
               },
               "193_2602282145PC8043282145PC16870107151P472": {
                  index: 2,
                  selected: true,
                  disabled: false,
                  estimatedPrice: false,
                  identifier: "193_2602282145PC8043282145PC16870107151P472",
                  brandCode: "P472",
                  brandName: "Saver",
                  brandTitle: "Saver",
                  baggageInfo: "15KG",
                  flightClass: "I",
                  cabinType: 1,
                  features: [
                     {
                        type: 8,
                        state: 1,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                     },
                     {
                        type: 1,
                        state: 1,
                        info: "15 Kg Check-in Baggage",
                     },
                     {
                        type: 5,
                        state: 2,
                        info: "Refund/Reissue without Penalty",
                     },
                     {
                        type: 2,
                        state: 2,
                        info: "Standard Seat Selection",
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Feta Cheese Sandwich",
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Chicken Sandwich",
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Bike",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Movies, TV Series, Music, Games",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "RFISC:SCHD",
                     },
                  ],
                  ssrs: [
                     {
                        type: 8,
                        state: 1,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                        paxes: {},
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                        paxes: {},
                     },
                     {
                        type: 5,
                        state: 2,
                        info: "Refund/Reissue without Penalty",
                        paxes: {},
                     },
                     {
                        type: 2,
                        state: 2,
                        info: "Standard Seat Selection",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Feta Cheese Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Chicken Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 2,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Bike",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Movies, TV Series, Music, Games",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "RFISC:SCHD",
                        paxes: {},
                     },
                  ],
                  total: {
                     source: "0.00",
                     parsedValue: 0,
                  },
                  currency: "EUR",
               },
               "193_2602282145PC8043282145PC16870107151P510": {
                  index: 3,
                  selected: false,
                  disabled: false,
                  estimatedPrice: false,
                  identifier: "193_2602282145PC8043282145PC16870107151P510",
                  brandCode: "P510",
                  brandName: "Saver Plus",
                  brandTitle: "Saver Plus",
                  baggageInfo: "20KG",
                  flightClass: "I",
                  cabinType: 1,
                  features: [
                     {
                        type: 8,
                        state: 1,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                     },
                     {
                        type: 1,
                        state: 1,
                        info: "20 Kg Check-in Baggage",
                     },
                     {
                        type: 5,
                        state: 2,
                        info: "Refund/Reissue without Penalty",
                     },
                     {
                        type: 2,
                        state: 1,
                        info: "Standard Seat Selection",
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Feta Cheese Sandwich",
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Chicken Sandwich",
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Bike",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Movies, TV Series, Music, Games",
                     },
                     {
                        type: 0,
                        state: 1,
                        info: "RFISC:SCHD",
                     },
                  ],
                  ssrs: [
                     {
                        type: 8,
                        state: 1,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                        paxes: {},
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                        paxes: {},
                     },
                     {
                        type: 5,
                        state: 2,
                        info: "Refund/Reissue without Penalty",
                        paxes: {},
                     },
                     {
                        type: 2,
                        state: 1,
                        info: "Standard Seat Selection",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Feta Cheese Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Chicken Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Bike",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "Movies, TV Series, Music, Games",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 1,
                        info: "RFISC:SCHD",
                        paxes: {},
                     },
                  ],
                  total: {
                     source: "189.00",
                     parsedValue: 189,
                  },
                  currency: "EUR",
               },
               "193_2602282145PC8043282145PC16870107151P721": {
                  index: 4,
                  selected: false,
                  disabled: false,
                  estimatedPrice: false,
                  identifier: "193_2602282145PC8043282145PC16870107151P721",
                  brandCode: "P721",
                  brandName: "Comfort Flex",
                  brandTitle: "Comfort Flex",
                  baggageInfo: "20KG",
                  flightClass: "I",
                  cabinType: 1,
                  features: [
                     {
                        type: 8,
                        state: 1,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                     },
                     {
                        type: 1,
                        state: 1,
                        info: "20 Kg Check-in Baggage",
                     },
                     {
                        type: 5,
                        state: 1,
                        info: "Refund/Reissue without Penalty",
                     },
                     {
                        type: 2,
                        state: 1,
                        info: "Standard Seat Selection",
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Feta Cheese Sandwich",
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Chicken Sandwich",
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                     },
                     {
                        type: 0,
                        state: 1,
                        info: "Bike",
                     },
                     {
                        type: 0,
                        state: 1,
                        info: "Movies, TV Series, Music, Games",
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "RFISC:SCHD",
                     },
                  ],
                  ssrs: [
                     {
                        type: 8,
                        state: 1,
                        info: "No cabin baggage allowance. (55x40x20 cm)",
                        paxes: {},
                     },
                     {
                        type: 8,
                        state: 1,
                        info: "1 Piece of Underseat Bag Only\n(40x30x15 cm, 3kg)",
                        paxes: {},
                     },
                     {
                        type: 5,
                        state: 1,
                        info: "Refund/Reissue without Penalty",
                        paxes: {},
                     },
                     {
                        type: 2,
                        state: 1,
                        info: "Standard Seat Selection",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Feta Cheese Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Chicken Sandwich",
                        paxes: {},
                     },
                     {
                        type: 3,
                        state: 1,
                        info: "Ham and Kasseri Cheese Panetipo Sandwich",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 1,
                        info: "Bike",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 1,
                        info: "Movies, TV Series, Music, Games",
                        paxes: {},
                     },
                     {
                        type: 0,
                        state: 2,
                        info: "RFISC:SCHD",
                        paxes: {},
                     },
                  ],
                  total: {
                     source: "648.00",
                     parsedValue: 648,
                  },
                  currency: "EUR",
               },
            },
            ssrs: [
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-CLh1prUHd7w6iIlmuRn0qSQ99o90MviOogTwD7YciCEEh8eF%2FvDhMLvv9nfn%2FH3nUN75qnXvr1NsHSE7yWepT6QCugOkzmltYwihy0ZoONM%3D|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|1|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-CLh1prUHd7w6iIlmuRn0qdVY0y%2BKhXYMWb9%2Fo8Q%2FPmcEh8eF%2FvDhMLvv9nfn%2FH3n0AWlfKo9Fb1qeD0jkF3z16QCugOkzmltYwihy0ZoONM%3D|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|2|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-CLh1prUHd7w6iIlmuRn0qdblmCjh10tbESpTF73sslVdwYy3YfOipXlgUuZ4kOnb3FYkCsw0FDwHrSn7lfWA96QCugOkzmltYwihy0ZoONM%3D|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|3|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                  },
                  ssrType: 1,
                  ssrSubType: "XBAG-5KG",
                  value: "5",
                  unit: "KG",
                  price: {
                     source: "44.00",
                     parsedValue: 44,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-QN73GNBkK4PAphPQBoBGZZoYOa4XM5gFdRFD2y7b1m6MKlqjpL4WzHY32XkZZ46KGcSq%2BQg8OHl0fH%2BV6%2BtcBDUpMUvlfq2OmrmuJ7NeI0I%3D|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|1|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-QN73GNBkK4PAphPQBoBGZYCLv5ky%2BIpwTMAbfIrMal%2BMKlqjpL4WzHY32XkZZ46K%2FvwOqeQmTBKUymYmVhAO%2FTUpMUvlfq2OmrmuJ7NeI0I%3D|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|2|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-QN73GNBkK4PAphPQBoBGZdYbu44ZPoAqDI5iAckM806MKlqjpL4WzHY32XkZZ46K1gIzDui%2BGV0gz1VUIYazgDUpMUvlfq2OmrmuJ7NeI0I%3D|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|3|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                  },
                  ssrType: 1,
                  ssrSubType: "XBAG-10KG",
                  value: "10",
                  unit: "KG",
                  price: {
                     source: "88.00",
                     parsedValue: 88,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-QbLWg1AhwTDxGGQ60C3RSwn%2B8k1i8HbMxl8pYg0RIeeMKlqjpL4WzHY32XkZZ46KgvcbSNaQ9ZBju%2F%2BSQVtTyR%2FDFqbpE3epC%2FnvQL%2Bqcus%3D|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|1|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-QbLWg1AhwTDxGGQ60C3RSzATlhDmRXvSp4%2BsU6%2FhUOiMKlqjpL4WzHY32XkZZ46KDIV%2FU5KnKB%2Bb39rMLAEcax%2FDFqbpE3epC%2FnvQL%2Bqcus%3D|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|2|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-QbLWg1AhwTDxGGQ60C3RS9AA0uuJZDVQJpp8oNzlaFeMKlqjpL4WzHY32XkZZ46KxeAMqX73UgNisdMcjTnkOB%2FDFqbpE3epC%2FnvQL%2Bqcus%3D|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|3|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                  },
                  ssrType: 1,
                  ssrSubType: "XBAG-15KG",
                  value: "15",
                  unit: "KG",
                  price: {
                     source: "132.00",
                     parsedValue: 132,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-hVXqRvHK2pVnrL%2Fw4%2BTrH62y%2FD898HfftWwnpHu9UBOMKlqjpL4WzHY32XkZZ46KfuCBpU%2BhuE1OjAhFoSEzA1d%2BzZ2KnzvTxgXFmnERfFo%3D|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|1|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-hVXqRvHK2pVnrL%2Fw4%2BTrH4OE2x2QVUJyB%2FLJV7IvK3iMKlqjpL4WzHY32XkZZ46KdCdaBonEoDD%2BQQHNQDImoVd%2BzZ2KnzvTxgXFmnERfFo%3D|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|2|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-hVXqRvHK2pVnrL%2Fw4%2BTrHwiBqTxU7QuyDlEcs%2B2AHQiMKlqjpL4WzHY32XkZZ46KAcyI98yxMlKYkWEtkrM8RVd%2BzZ2KnzvTxgXFmnERfFo%3D|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|3|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                  },
                  ssrType: 1,
                  ssrSubType: "XBAG-25KG",
                  value: "25",
                  unit: "KG",
                  price: {
                     source: "220.00",
                     parsedValue: 220,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-Cn27G6Oy3sJn85I31iVXmdBVBYPpIHaVypFSJNJSVPiMKlqjpL4WzHY32XkZZ46K%2Bj20cvgf8SmBiKTEVws5pJ%2FKTT2VFDiAq4TBt1c2H50%3D|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|1|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-Cn27G6Oy3sJn85I31iVXmWoCMBcwf9b0NfC4S24t%2FWuMKlqjpL4WzHY32XkZZ46KzsPDpOonuqXakkAaOYzNMJ%2FKTT2VFDiAq4TBt1c2H50%3D|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|2|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-Cn27G6Oy3sJn85I31iVXmUzeC%2FudnF6zuP2RqqDhFLmMKlqjpL4WzHY32XkZZ46K%2FZNLwRo30sNGYhporXLZap%2FKTT2VFDiAq4TBt1c2H50%3D|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                        2: {
                           key: "Version2|3|2|FREE_OF_CHARGE_CONJUNCTED_SEGMENT",
                           selected: false,
                           freeOfChargeConjunctedSegment: true,
                        },
                     },
                  },
                  ssrType: 1,
                  ssrSubType: "XBAG-35KG",
                  value: "35",
                  unit: "KG",
                  price: {
                     source: "308.00",
                     parsedValue: 308,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GRNB|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GRNB|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GRNB|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_GRNB",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "6.00",
                     parsedValue: 6,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GRNS|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GRNS|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GRNS|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_GRNS",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "6.00",
                     parsedValue: 6,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BOWL|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BOWL|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BOWL|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BOWL",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "10.00",
                     parsedValue: 10,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-CHPL|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-CHPL|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-CHPL|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_CHPL",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "10.00",
                     parsedValue: 10,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SPCC|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SPCC|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SPCC|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SPCC",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "10.00",
                     parsedValue: 10,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BDAY|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BDAY|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BDAY|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BDAY",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "4.00",
                     parsedValue: 4,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BPSW|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BPSW|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-BPSW|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BPSW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-JASW|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-JASW|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-JASW|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_JASW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TASW|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TASW|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TASW|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_TASW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-EKSW|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-EKSW|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-EKSW|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_EKSW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-VGWR|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-VGWR|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-VGWR|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_VGWR",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.00",
                     parsedValue: 8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-KRVP|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-KRVP|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-KRVP|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_KRVP",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.00",
                     parsedValue: 8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-PEWR|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-PEWR|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-PEWR|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_PEWR",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.00",
                     parsedValue: 8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-PEYS|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-PEYS|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-PEYS|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_PEYS",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GFSW|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GFSW|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-GFSW|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_GFSW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TAWR|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TAWR|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TAWR|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_TAWR",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.00",
                     parsedValue: 8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDC|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDC|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDC|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDC",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "13.00",
                     parsedValue: 13,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDA|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDA|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDA|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "9.00",
                     parsedValue: 9,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDK|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDK|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDK|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDK",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "9.00",
                     parsedValue: 9,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDF|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDF|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-SLDF|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDF",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TOST|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TOST|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-TOST|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_TOST",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-NODL|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-NODL|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-NODL|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_NODL",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "4.00",
                     parsedValue: 4,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        1: {
                           key: "Version2|1|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-DSRA|PAX-1-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        1: {
                           key: "Version2|2|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-DSRA|PAX-2-ADT|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        1: {
                           key: "Version2|3|1|AlaCarteOffer-186371ec12ff46ac8d5dbbcd6f6855ee|AlaCarteOfferItem-DSRA|PAX-3-CHD|PAXSEG-NDg3Mjg1Nw==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_DSRA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "10.00",
                     parsedValue: 10,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PIZA|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PIZA|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PIZA|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_PIZA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PNCK|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PNCK|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PNCK|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_PNCK",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "7.00",
                     parsedValue: 7,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GRNB|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GRNB|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GRNB|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_GRNB",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.00",
                     parsedValue: 8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GRNS|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GRNS|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GRNS|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_GRNS",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.00",
                     parsedValue: 8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-OMLT|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-OMLT|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-OMLT|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_OMLT",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "13.00",
                     parsedValue: 13,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CHPL|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CHPL|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CHPL|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_CHPL",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "13.00",
                     parsedValue: 13,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BOWL|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BOWL|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BOWL|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BOWL",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "13.00",
                     parsedValue: 13,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MCCH|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MCCH|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MCCH|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_MCCH",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "10.00",
                     parsedValue: 10,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BEEF|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BEEF|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BEEF|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BEEF",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "14.00",
                     parsedValue: 14,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-FING|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-FING|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-FING|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_FING",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "12.00",
                     parsedValue: 12,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LSNG|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LSNG|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LSNG|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_LSNG",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "10.00",
                     parsedValue: 10,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CHMB|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CHMB|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CHMB|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_CHMB",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "13.00",
                     parsedValue: 13,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SPCC|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SPCC|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SPCC|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SPCC",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BDAY|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BDAY|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BDAY|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BDAY",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.00",
                     parsedValue: 8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CBRA|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CBRA|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CBRA|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_CBRA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "16.00",
                     parsedValue: 16,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CBRB|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CBRB|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-CBRB|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_CBRB",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "16.00",
                     parsedValue: 16,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BPSW|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BPSW|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BPSW|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BPSW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.80",
                     parsedValue: 8.8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-JASW|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-JASW|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-JASW|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_JASW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.80",
                     parsedValue: 8.8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TASW|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TASW|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TASW|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_TASW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.80",
                     parsedValue: 8.8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TOST|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TOST|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TOST|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_TOST",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.80",
                     parsedValue: 8.8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PEWR|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PEWR|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PEWR|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_PEWR",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "12.00",
                     parsedValue: 12,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-VGWR|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-VGWR|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-VGWR|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_VGWR",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "12.00",
                     parsedValue: 12,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-KRVP|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-KRVP|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-KRVP|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_KRVP",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "12.00",
                     parsedValue: 12,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-EKSW|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-EKSW|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-EKSW|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_EKSW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.80",
                     parsedValue: 8.8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PEYS|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PEYS|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PEYS|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_PEYS",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.80",
                     parsedValue: 8.8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GFSW|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GFSW|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GFSW|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_GFSW",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "8.80",
                     parsedValue: 8.8,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DNWR|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DNWR|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DNWR|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_DNWR",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "15.00",
                     parsedValue: 15,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TAWR|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TAWR|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-TAWR|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_TAWR",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "12.00",
                     parsedValue: 12,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDK|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDK|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDK|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDK",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "13.00",
                     parsedValue: 13,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDA|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDA|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDA|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "13.00",
                     parsedValue: 13,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDC|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDC|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDC|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDC",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "16.00",
                     parsedValue: 16,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-HMPA|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-HMPA|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-HMPA|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_HMPA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "16.00",
                     parsedValue: 16,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BRYN|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BRYN|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BRYN|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BRYN",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "14.40",
                     parsedValue: 14.4,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MLTA|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MLTA|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MLTA|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_MLTA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "16.00",
                     parsedValue: 16,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LVRK|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LVRK|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LVRK|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_LVRK",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "24.00",
                     parsedValue: 24,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MLKF|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MLKF|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-MLKF|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_MLKF",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "14.40",
                     parsedValue: 14.4,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-NODL|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-NODL|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-NODL|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_NODL",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "5.60",
                     parsedValue: 5.6,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-HMCH|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-HMCH|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-HMCH|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_HMCH",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "14.40",
                     parsedValue: 14.4,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDF|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDF|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-SLDF|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_SLDF",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "11.00",
                     parsedValue: 11,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DSRA|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DSRA|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DSRA|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_DSRA",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "14.00",
                     parsedValue: 14,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-VGML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-VGML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-VGML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_VGML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GFML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GFML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-GFML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_GFML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LSML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LSML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LSML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_LSML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PFML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PFML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-PFML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_PFML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DBML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DBML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-DBML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_DBML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-NLML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-NLML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-NLML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_NLML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LCML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LCML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LCML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_LCML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LFML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LFML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-LFML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_LFML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
               {
                  eligiblePaxSegmentKeys: {
                     1: {
                        2: {
                           key: "Version2|1|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BLML|PAX-1-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     2: {
                        2: {
                           key: "Version2|2|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BLML|PAX-2-ADT|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                     3: {
                        2: {
                           key: "Version2|3|2|AlaCarteOffer-75c188d2083a436ab529166062df713f|AlaCarteOfferItem-BLML|PAX-3-CHD|PAXSEG-NDg3NDc0NA==",
                           selected: false,
                           freeOfChargeConjunctedSegment: false,
                        },
                     },
                  },
                  ssrType: 3,
                  ssrSubType: "PC_BLML",
                  value: "1",
                  unit: "PC",
                  price: {
                     source: "17.00",
                     parsedValue: 17,
                  },
                  currency: "EUR",
               },
            ],
            extraSsrs: {
               BAGGAGE: {
                  "1|XBAG-5KG": {
                     index: 1,
                     selected: false,
                     identifier: "1|XBAG-5KG",
                     ssrType: 1,
                     nonVoidable: true,
                     value: "5",
                     unit: "KG",
                     info: "XBAG-5KG",
                     rfisc: "XBAG-5KG",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "132.00",
                        parsedValue: 132,
                     },
                     currency: "EUR",
                  },
                  "1|XBAG-10KG": {
                     index: 2,
                     selected: false,
                     identifier: "1|XBAG-10KG",
                     ssrType: 1,
                     nonVoidable: true,
                     value: "10",
                     unit: "KG",
                     info: "XBAG-10KG",
                     rfisc: "XBAG-10KG",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "264.00",
                        parsedValue: 264,
                     },
                     currency: "EUR",
                  },
                  "1|XBAG-15KG": {
                     index: 3,
                     selected: false,
                     identifier: "1|XBAG-15KG",
                     ssrType: 1,
                     nonVoidable: true,
                     value: "15",
                     unit: "KG",
                     info: "XBAG-15KG",
                     rfisc: "XBAG-15KG",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "396.00",
                        parsedValue: 396,
                     },
                     currency: "EUR",
                  },
                  "1|XBAG-25KG": {
                     index: 4,
                     selected: false,
                     identifier: "1|XBAG-25KG",
                     ssrType: 1,
                     nonVoidable: true,
                     value: "25",
                     unit: "KG",
                     info: "XBAG-25KG",
                     rfisc: "XBAG-25KG",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "660.00",
                        parsedValue: 660,
                     },
                     currency: "EUR",
                  },
                  "1|XBAG-35KG": {
                     index: 5,
                     selected: false,
                     identifier: "1|XBAG-35KG",
                     ssrType: 1,
                     nonVoidable: true,
                     value: "35",
                     unit: "KG",
                     info: "XBAG-35KG",
                     rfisc: "XBAG-35KG",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "924.00",
                        parsedValue: 924,
                     },
                     currency: "EUR",
                  },
               },
               MEAL: {
                  "1|GRNB": {
                     index: 6,
                     selected: false,
                     identifier: "1|GRNB",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "GRNB",
                     unit: "PC",
                     info: "BREAKFAST",
                     rfisc: "GRNB",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "18.00",
                        parsedValue: 18,
                     },
                     currency: "EUR",
                  },
                  "1|GRNS": {
                     index: 7,
                     selected: false,
                     identifier: "1|GRNS",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "GRNS",
                     unit: "PC",
                     info: "BREAKFAST",
                     rfisc: "GRNS",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "18.00",
                        parsedValue: 18,
                     },
                     currency: "EUR",
                  },
                  "1|BOWL": {
                     index: 8,
                     selected: false,
                     identifier: "1|BOWL",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "BOWL",
                     unit: "PC",
                     info: "SALAD",
                     rfisc: "BOWL",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "30.00",
                        parsedValue: 30,
                     },
                     currency: "EUR",
                  },
                  "1|CHPL": {
                     index: 9,
                     selected: false,
                     identifier: "1|CHPL",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "CHPL",
                     unit: "PC",
                     info: "SALAD",
                     rfisc: "CHPL",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "30.00",
                        parsedValue: 30,
                     },
                     currency: "EUR",
                  },
                  "1|SPCC": {
                     index: 10,
                     selected: false,
                     identifier: "1|SPCC",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "SPCC",
                     unit: "PC",
                     info: "UNDEFINED",
                     rfisc: "SPCC",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "30.00",
                        parsedValue: 30,
                     },
                     currency: "EUR",
                  },
                  "1|BDAY": {
                     index: 11,
                     selected: false,
                     identifier: "1|BDAY",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "BDAY",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "BDAY",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "12.00",
                        parsedValue: 12,
                     },
                     currency: "EUR",
                  },
                  "1|BPSW": {
                     index: 12,
                     selected: false,
                     identifier: "1|BPSW",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "BPSW",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "BPSW",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|JASW": {
                     index: 13,
                     selected: false,
                     identifier: "1|JASW",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "JASW",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "JASW",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|TASW": {
                     index: 14,
                     selected: false,
                     identifier: "1|TASW",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "TASW",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "TASW",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|EKSW": {
                     index: 15,
                     selected: false,
                     identifier: "1|EKSW",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "EKSW",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "EKSW",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|VGWR": {
                     index: 16,
                     selected: false,
                     identifier: "1|VGWR",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "VGWR",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "VGWR",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "24.00",
                        parsedValue: 24,
                     },
                     currency: "EUR",
                  },
                  "1|KRVP": {
                     index: 17,
                     selected: false,
                     identifier: "1|KRVP",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "KRVP",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "KRVP",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "24.00",
                        parsedValue: 24,
                     },
                     currency: "EUR",
                  },
                  "1|PEWR": {
                     index: 18,
                     selected: false,
                     identifier: "1|PEWR",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "PEWR",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "PEWR",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "24.00",
                        parsedValue: 24,
                     },
                     currency: "EUR",
                  },
                  "1|PEYS": {
                     index: 19,
                     selected: false,
                     identifier: "1|PEYS",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "PEYS",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "PEYS",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|GFSW": {
                     index: 20,
                     selected: false,
                     identifier: "1|GFSW",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "GFSW",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "GFSW",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|TAWR": {
                     index: 21,
                     selected: false,
                     identifier: "1|TAWR",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "TAWR",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "TAWR",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "24.00",
                        parsedValue: 24,
                     },
                     currency: "EUR",
                  },
                  "1|SLDC": {
                     index: 22,
                     selected: false,
                     identifier: "1|SLDC",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "SLDC",
                     unit: "PC",
                     info: "SALAD",
                     rfisc: "SLDC",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "39.00",
                        parsedValue: 39,
                     },
                     currency: "EUR",
                  },
                  "1|SLDA": {
                     index: 23,
                     selected: false,
                     identifier: "1|SLDA",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "SLDA",
                     unit: "PC",
                     info: "SALAD",
                     rfisc: "SLDA",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "27.00",
                        parsedValue: 27,
                     },
                     currency: "EUR",
                  },
                  "1|SLDK": {
                     index: 24,
                     selected: false,
                     identifier: "1|SLDK",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "SLDK",
                     unit: "PC",
                     info: "SALAD",
                     rfisc: "SLDK",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "27.00",
                        parsedValue: 27,
                     },
                     currency: "EUR",
                  },
                  "1|SLDF": {
                     index: 25,
                     selected: false,
                     identifier: "1|SLDF",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "SLDF",
                     unit: "PC",
                     info: "SALAD",
                     rfisc: "SLDF",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|TOST": {
                     index: 26,
                     selected: false,
                     identifier: "1|TOST",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "TOST",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "TOST",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|NODL": {
                     index: 27,
                     selected: false,
                     identifier: "1|NODL",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "NODL",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "NODL",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "12.00",
                        parsedValue: 12,
                     },
                     currency: "EUR",
                  },
                  "1|DSRA": {
                     index: 28,
                     selected: false,
                     identifier: "1|DSRA",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "DSRA",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "DSRA",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "30.00",
                        parsedValue: 30,
                     },
                     currency: "EUR",
                  },
                  "1|PIZA": {
                     index: 29,
                     selected: false,
                     identifier: "1|PIZA",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "PIZA",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "PIZA",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|PNCK": {
                     index: 30,
                     selected: false,
                     identifier: "1|PNCK",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "PNCK",
                     unit: "PC",
                     info: "BREAKFAST",
                     rfisc: "PNCK",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "21.00",
                        parsedValue: 21,
                     },
                     currency: "EUR",
                  },
                  "1|OMLT": {
                     index: 31,
                     selected: false,
                     identifier: "1|OMLT",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "OMLT",
                     unit: "PC",
                     info: "BREAKFAST",
                     rfisc: "OMLT",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "39.00",
                        parsedValue: 39,
                     },
                     currency: "EUR",
                  },
                  "1|MCCH": {
                     index: 32,
                     selected: false,
                     identifier: "1|MCCH",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "MCCH",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "MCCH",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "30.00",
                        parsedValue: 30,
                     },
                     currency: "EUR",
                  },
                  "1|BEEF": {
                     index: 33,
                     selected: false,
                     identifier: "1|BEEF",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "BEEF",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "BEEF",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "42.00",
                        parsedValue: 42,
                     },
                     currency: "EUR",
                  },
                  "1|FING": {
                     index: 34,
                     selected: false,
                     identifier: "1|FING",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "FING",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "FING",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "36.00",
                        parsedValue: 36,
                     },
                     currency: "EUR",
                  },
                  "1|LSNG": {
                     index: 35,
                     selected: false,
                     identifier: "1|LSNG",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "LSNG",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "LSNG",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "30.00",
                        parsedValue: 30,
                     },
                     currency: "EUR",
                  },
                  "1|CHMB": {
                     index: 36,
                     selected: false,
                     identifier: "1|CHMB",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "CHMB",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "CHMB",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "39.00",
                        parsedValue: 39,
                     },
                     currency: "EUR",
                  },
                  "1|CBRA": {
                     index: 37,
                     selected: false,
                     identifier: "1|CBRA",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "CBRA",
                     unit: "PC",
                     info: "BREAKFAST",
                     rfisc: "CBRA",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "48.00",
                        parsedValue: 48,
                     },
                     currency: "EUR",
                  },
                  "1|CBRB": {
                     index: 38,
                     selected: false,
                     identifier: "1|CBRB",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "CBRB",
                     unit: "PC",
                     info: "BREAKFAST",
                     rfisc: "CBRB",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "48.00",
                        parsedValue: 48,
                     },
                     currency: "EUR",
                  },
                  "1|DNWR": {
                     index: 39,
                     selected: false,
                     identifier: "1|DNWR",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "DNWR",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "DNWR",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "45.00",
                        parsedValue: 45,
                     },
                     currency: "EUR",
                  },
                  "1|HMPA": {
                     index: 40,
                     selected: false,
                     identifier: "1|HMPA",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "HMPA",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "HMPA",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "48.00",
                        parsedValue: 48,
                     },
                     currency: "EUR",
                  },
                  "1|BRYN": {
                     index: 41,
                     selected: false,
                     identifier: "1|BRYN",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "BRYN",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "BRYN",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "43.20",
                        parsedValue: 43.2,
                     },
                     currency: "EUR",
                  },
                  "1|MLTA": {
                     index: 42,
                     selected: false,
                     identifier: "1|MLTA",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "MLTA",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "MLTA",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "48.00",
                        parsedValue: 48,
                     },
                     currency: "EUR",
                  },
                  "1|LVRK": {
                     index: 43,
                     selected: false,
                     identifier: "1|LVRK",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "LVRK",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "LVRK",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "72.00",
                        parsedValue: 72,
                     },
                     currency: "EUR",
                  },
                  "1|MLKF": {
                     index: 44,
                     selected: false,
                     identifier: "1|MLKF",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "MLKF",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "MLKF",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "43.20",
                        parsedValue: 43.2,
                     },
                     currency: "EUR",
                  },
                  "1|HMCH": {
                     index: 45,
                     selected: false,
                     identifier: "1|HMCH",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "HMCH",
                     unit: "PC",
                     info: "MAIN CATERING",
                     rfisc: "HMCH",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "43.20",
                        parsedValue: 43.2,
                     },
                     currency: "EUR",
                  },
                  "1|VGML": {
                     index: 46,
                     selected: false,
                     identifier: "1|VGML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "VGML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "VGML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|GFML": {
                     index: 47,
                     selected: false,
                     identifier: "1|GFML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "GFML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "GFML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|LSML": {
                     index: 48,
                     selected: false,
                     identifier: "1|LSML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "LSML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "LSML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|PFML": {
                     index: 49,
                     selected: false,
                     identifier: "1|PFML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "PFML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "PFML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|DBML": {
                     index: 50,
                     selected: false,
                     identifier: "1|DBML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "DBML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "DBML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|NLML": {
                     index: 51,
                     selected: false,
                     identifier: "1|NLML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "NLML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "NLML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|LCML": {
                     index: 52,
                     selected: false,
                     identifier: "1|LCML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "LCML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "LCML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|LFML": {
                     index: 53,
                     selected: false,
                     identifier: "1|LFML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "LFML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "LFML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
                  "1|BLML": {
                     index: 54,
                     selected: false,
                     identifier: "1|BLML",
                     ssrType: 3,
                     nonVoidable: true,
                     value: "BLML",
                     unit: "PC",
                     info: "SPECIAL CATERING",
                     rfisc: "BLML",
                     paxes: {
                        ADULT: true,
                        CHILD: true,
                     },
                     total: {
                        source: "51.00",
                        parsedValue: 51,
                     },
                     currency: "EUR",
                  },
               },
            },
            segments: [
               {
                  index: 1,
                  cabinType: 1,
                  departureAirportCode: "AYT",
                  departureAirportNameDic: {
                     TURKISH: "Antalya Havalimanı",
                     ENGLISH: "Antalya Airport",
                     GERMAN: "Antalya Flughafen",
                  },
                  arrivalAirportCode: "ESB",
                  arrivalAirportNameDic: {
                     TURKISH: "Esenboğa Havalimanı",
                     ENGLISH: "Esenboga Airport",
                     GERMAN: "Esenboga Flughafen",
                  },
                  marketingAirlineCode: "PC",
                  operatingAirlineCode: "PC",
                  departureDateTime: "2026-02-28T21:45:00",
                  arrivalDateTime: "2026-02-28T22:50:00",
                  travelTime: "01:05:00",
                  flightNumber: "PC8043",
                  flightClass: "I",
                  brandName: "Saver",
                  paxesBaggages: {
                     ADULT: "15KG",
                     CHILD: "15KG",
                  },
                  departureDateTimeChanged: false,
                  arrivalDateTimeChanged: false,
                  flightClassChanged: false,
                  cabinTypeChanged: false,
                  stopCount: 0,
               },
               {
                  index: 2,
                  cabinType: 1,
                  departureAirportCode: "ESB",
                  departureAirportNameDic: {
                     TURKISH: "Esenboğa Havalimanı",
                     ENGLISH: "Esenboga Airport",
                     GERMAN: "Esenboga Flughafen",
                  },
                  arrivalAirportCode: "DUS",
                  arrivalAirportNameDic: {
                     TURKISH: "Düsseldorf Havalimanı",
                     ENGLISH: "Dusseldorf Airport",
                     GERMAN: "Dusseldorf Flughafen",
                  },
                  marketingAirlineCode: "PC",
                  operatingAirlineCode: "PC",
                  departureDateTime: "2026-03-01T07:15:00",
                  arrivalDateTime: "2026-03-01T09:00:00",
                  travelTime: "03:45:00",
                  flightNumber: "PC1687",
                  flightClass: "T",
                  brandName: "Saver",
                  paxesBaggages: {
                     ADULT: "15KG",
                     CHILD: "15KG",
                  },
                  departureDateTimeChanged: false,
                  arrivalDateTimeChanged: false,
                  flightClassChanged: false,
                  cabinTypeChanged: false,
                  stopCount: 0,
               },
            ],
            amount: null,
         },
      },
      paxes: {
         ADULT: {
            count: 2,
            type: 1,
            subType: 0,
            amount: {
               fare: {
                  source: "342.00",
                  parsedValue: 342,
               },
               taxE: {
                  source: "150.00",
                  parsedValue: 150,
               },
               taxI: 0,
               airlineTotal: {
                  source: "492.00",
                  parsedValue: 492,
               },
               fareMarkups: 0,
               otherMarkups: {
                  source: "2.00",
                  parsedValue: 2,
               },
               otherMarkdowns: 0,
               grandTotal: {
                  source: "494.00",
                  parsedValue: 494,
               },
               currency: "EUR",
               marksBreakdown: {
                  paxType: 0,
                  paxSubType: 0,
                  sf: {
                     source: "2.00",
                     parsedValue: 2,
                  },
                  gc: 0,
                  ac: 0,
                  ace: {
                     source: "0.0",
                     parsedValue: 0,
                  },
                  pc: 0,
                  pce: 0,
                  pde: {
                     source: "20.00",
                     parsedValue: 20,
                  },
                  vc: 0,
                  tf: 0,
                  rtf: 0,
                  dif: 2,
               },
            },
         },
         CHILD: {
            count: 1,
            type: 2,
            subType: 0,
            amount: {
               fare: {
                  source: "171.00",
                  parsedValue: 171,
               },
               taxE: {
                  source: "75.00",
                  parsedValue: 75,
               },
               taxI: 0,
               airlineTotal: {
                  source: "246.00",
                  parsedValue: 246,
               },
               fareMarkups: 0,
               otherMarkups: {
                  source: "1.00",
                  parsedValue: 1,
               },
               otherMarkdowns: 0,
               grandTotal: {
                  source: "247.00",
                  parsedValue: 247,
               },
               currency: "EUR",
               marksBreakdown: {
                  paxType: 0,
                  paxSubType: 0,
                  sf: {
                     source: "1.00",
                     parsedValue: 1,
                  },
                  gc: 0,
                  ac: 0,
                  ace: {
                     source: "0.0",
                     parsedValue: 0,
                  },
                  pc: 0,
                  pce: 0,
                  pde: {
                     source: "10.00",
                     parsedValue: 10,
                  },
                  vc: 0,
                  tf: 0,
                  rtf: 0,
                  dif: 1,
               },
            },
         },
      },
      paymentChoiceDetail: {
         note: null,
         warning: null,
         enabled: true,
         reversable: false,
         paymentChoices: [
            {
               enabled: true,
               reservationEnabled: false,
               commissionEnabled: false,
               paymentType: 1,
               trxTypes: [2, 3],
               index: 1,
               vposId: 0,
               amount: {
                  source: "741.00",
                  parsedValue: 741,
               },
               commission: 0,
               total: {
                  source: "741.00",
                  parsedValue: 741,
               },
               balance: {
                  source: "31077.60",
                  parsedValue: 31077.6,
               },
               currency: "EUR",
               note: null,
            },
            {
               enabled: true,
               reservationEnabled: false,
               commissionEnabled: true,
               paymentType: 4,
               trxTypes: [2, 3],
               index: 2,
               vposId: 2,
               amount: {
                  source: "741.00",
                  parsedValue: 741,
               },
               commission: 22.23,
               total: 763.23,
               balance: 0,
               currency: "EUR",
               note: null,
            },
            {
               enabled: true,
               reservationEnabled: false,
               commissionEnabled: false,
               paymentType: 5,
               trxTypes: [2, 3],
               index: 3,
               vposId: 11,
               amount: {
                  source: "741.00",
                  parsedValue: 741,
               },
               commission: 0,
               total: {
                  source: "741.00",
                  parsedValue: 741,
               },
               balance: 0,
               currency: "EUR",
               note: null,
            },
            {
               enabled: true,
               reservationEnabled: false,
               commissionEnabled: true,
               paymentType: 2,
               trxTypes: [2, 3],
               index: 4,
               vposId: 26,
               amount: {
                  source: "741.00",
                  parsedValue: 741,
               },
               commission: 14.82,
               total: 755.82,
               balance: 0,
               currency: "EUR",
               note: null,
            },
         ],
      },
      total: {
         total: {
            source: "741.00",
            parsedValue: 741,
         },
         agencyCommissionExtra: {
            source: "0.0",
            parsedValue: 0,
         },
         grandTotal: {
            source: "741.00",
            parsedValue: 741,
         },
         currency: "EUR",
      },
      inputs: {
         docs: false,
         foid: false,
         tckn: false,
         hesCode: false,
         milesCard: false,
      },
      notes: {
         4: "<p>INGILIZCE</p>",
         6: '<p>test ingilizce<mark class="marker-yellow">HANDE</mark></p>',
      },
      warnings: {},
      invalidPackage: false,
      pricePerLeg: true,
      pnrCount: 1,
   },
};
